import { LeMagFeaturedArticle } from "@blacknut/react-client-core/lib";
import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import styles from "./styles.module.scss";
import React from "react";
interface LeMagArticleListItemProps {
  article: LeMagFeaturedArticle;
  onPressEnter: () => void;
}
const LeMagArticleListItem = ({ article, onPressEnter }: LeMagArticleListItemProps) => {
  return (
    <Focusable onPressEnter={onPressEnter} className={clsx(styles.container)}>
      <img className={styles.image} src={article.image_1by1} />
      <div className={styles.mask}>
        <div className={styles.title}>{article.title}</div>
        <div className={styles.wrap} style={{ backgroundColor: article.tile_color }}>
          <div className={styles.description}>{article.description}</div>
        </div>
      </div>
    </Focusable>
  );
};
export default LeMagArticleListItem;
